export default __webpack_public_path__ + "static/media/not-configured-indicator 2.d4862b19.svg";